import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/envs/environnement';

export interface ChatResponse {
    response: string;
}

@Injectable({
    providedIn: 'root'
})
export class IaChatService {
    private apiUrl = environment.baseUrl + '/chat/ask';

    constructor(private http: HttpClient) { }

    ask(message: string, structureId: string): Observable<ChatResponse> {
        return this.http.post<ChatResponse>(this.apiUrl, { message, structureId });
    }
}
